import { render, staticRenderFns } from "./Legalsupport.vue?vue&type=template&id=22ece4d0&"
import script from "./Legalsupport.vue?vue&type=script&lang=js&"
export * from "./Legalsupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports